"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const react_redux_1 = require("react-redux");
const Colors_1 = __importDefault(require("../../assets/colors/Colors"));
const images_1 = require("../../assets/images");
const constants_1 = require("../../constants");
const Routes_1 = __importDefault(require("../../navigators/Routes"));
const rootNavigation_1 = require("../../navigators/rootNavigation");
const helpler_1 = require("../../utils/helpler");
const scale_1 = require("../../utils/scale");
const button_1 = require("../button");
const CustomText_1 = __importDefault(require("../text/CustomText"));
const ModalMenu = (props) => {
    const { visible, onClose } = props;
    const insets = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const dataUser = (0, react_redux_1.useSelector)((state) => state.loginReducer.dataProfile, react_redux_1.shallowEqual);
    const translateX = (0, react_1.useRef)(new react_native_1.Animated.Value(0)).current;
    const isAnonymousUser = dataUser?.registration_status == 0;
    const Line = (text, onchange) => {
        const [isHovered, setIsHovered] = (0, react_1.useState)(false);
        return (react_1.default.createElement(react_native_1.Pressable, { style: ({ pressed }) => [
                {
                    width: '100%',
                    height: (0, scale_1.scale)(52),
                    paddingHorizontal: (0, scale_1.scale)(16),
                    justifyContent: 'center',
                    borderBottomWidth: 1,
                    borderBottomColor: '#E0E0E0',
                    ...react_native_1.Platform.select({
                        web: {
                            transitionProperty: 'all',
                            transitionDuration: '200ms',
                            transitionTimingFunction: 'ease',
                        },
                    }),
                },
                {
                    backgroundColor: isHovered || pressed ? '#EDEDED' : 'transparent',
                },
            ], onPress: () => {
                onchange(), onClose();
            }, onHoverIn: () => setIsHovered(true), onHoverOut: () => setIsHovered(false) },
            react_1.default.createElement(CustomText_1.default, { style: {
                    fontSize: (0, scale_1.moderateScale)(14),
                    fontWeight: '300',
                    lineHeight: (0, scale_1.moderateScale)(21),
                    color: '#292A33',
                } }, text)));
    };
    (0, react_1.useEffect)(() => {
        if (visible) {
            react_native_1.Animated.timing(translateX, {
                toValue: 1,
                duration: 300,
                useNativeDriver: false,
            }).start();
        }
    }, [visible]);
    const closeModal = () => {
        react_native_1.Animated.timing(translateX, {
            toValue: 0,
            duration: 300,
            useNativeDriver: false,
        }).start(() => onClose());
    };
    return (react_1.default.createElement(react_native_1.Modal, { visible: visible, animationType: "fade", statusBarTranslucent: true, transparent: true, onRequestClose: closeModal, onShow: () => {
            helpler_1.isWeb && document.body.classList.add("prevent-slice-modal");
        }, onDismiss: () => {
            helpler_1.isWeb && document.body.classList.remove("prevent-slice-modal");
        }, ...props },
        react_1.default.createElement(react_native_1.Pressable, { style: styles.viewContain, onPress: closeModal },
            react_1.default.createElement(react_native_1.View, { style: { width: scale_1.width, alignSelf: 'center', height: '100%', overflow: 'hidden' } },
                react_1.default.createElement(react_native_1.Animated.View, { style: [
                        styles.viewModal,
                        { paddingTop: insets.top },
                        {
                            transform: [
                                {
                                    translateX: translateX.interpolate({
                                        inputRange: [0, 1],
                                        outputRange: [-400, 0],
                                    }),
                                },
                            ],
                        },
                    ] },
                    react_1.default.createElement(react_native_1.View, { style: {
                            paddingHorizontal: (0, scale_1.scale)(16),
                            paddingVertical: (0, scale_1.scale)(20),
                            borderBottomColor: '#E0E0E0',
                            borderBottomWidth: 1,
                        } },
                        react_1.default.createElement(react_native_1.View, { style: {
                                flexDirection: 'row',
                                alignItems: 'center',
                                marginBottom: (0, scale_1.scale)(12),
                            } },
                            react_1.default.createElement(react_native_1.Pressable, { disabled: isAnonymousUser, onPress: () => {
                                    (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                                        screen: Routes_1.default.MY_PROFILE,
                                    });
                                    onClose();
                                } },
                                react_1.default.createElement(react_native_1.Image, { source: dataUser?.thumbnail_url
                                        ? { uri: dataUser.thumbnail_url }
                                        : images_1.images?.AvatarDefaul, style: {
                                        height: (0, scale_1.scale)(56),
                                        width: (0, scale_1.scale)(56),
                                        borderRadius: (0, scale_1.scale)(99),
                                        marginRight: (0, scale_1.scale)(12),
                                    } })),
                            react_1.default.createElement(react_native_1.View, { style: { flex: 1 } },
                                react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles.textbold }, isAnonymousUser
                                    ? 'アカウント未登録'
                                    : dataUser?.nickname || constants_1.DEFAULT_NAME),
                                dataUser?.user_handle && !isAnonymousUser && (react_1.default.createElement(CustomText_1.default, { numberOfLines: 1, style: styles.textnomal },
                                    "@",
                                    dataUser?.user_handle)))),
                        react_1.default.createElement(react_native_1.View, { style: { flexDirection: 'row', alignItems: 'center' } },
                            react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles.textbold, onPress: () => {
                                    if (isAnonymousUser)
                                        return;
                                    onClose();
                                    (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                                        screen: Routes_1.default.FOLLOW_SCREEN,
                                        params: {
                                            initTabIndex: 0,
                                            userHandle: dataUser?.user_handle,
                                        },
                                    });
                                } },
                                (0, helpler_1.formatNumber)(dataUser?.follows || 0),
                                ' ',
                                react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles.textnomal }, "\u30D5\u30A9\u30ED\u30FC")),
                            react_1.default.createElement(CustomText_1.default, { weight: "600", style: [styles.textbold, { marginLeft: (0, scale_1.scale)(16) }], onPress: () => {
                                    if (isAnonymousUser)
                                        return;
                                    onClose();
                                    (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                                        screen: Routes_1.default.FOLLOW_SCREEN,
                                        params: {
                                            initTabIndex: 1,
                                            userHandle: dataUser?.user_handle,
                                        },
                                    });
                                } },
                                (0, helpler_1.formatNumber)(dataUser?.followers || 0),
                                ' ',
                                react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles.textnomal }, "\u30D5\u30A9\u30ED\u30EF\u30FC"))),
                        dataUser && dataUser.registration_status == 0 && (react_1.default.createElement(button_1.LinearButton, { title: "\u30ED\u30B0\u30A4\u30F3\u30FB\u4F1A\u54E1\u767B\u9332", onPress: () => {
                                (0, rootNavigation_1.navigate)(Routes_1.default.AUTH_NAVIGATOR, { screen: Routes_1.default.LOGIN });
                                onClose();
                            }, style: {
                                width: '100%',
                                height: (0, scale_1.scale)(48),
                                borderRadius: (0, scale_1.scale)(4),
                            }, containerStyle: {
                                marginTop: (0, scale_1.scale)(20),
                            }, fontWeight: "600", textStyle: {
                                fontSize: (0, scale_1.moderateScale)(16),
                                lineHeight: (0, scale_1.moderateScale)(24),
                                color: '#FEFEFE',
                            } }))),
                    Line('ホーム', () => {
                        (0, rootNavigation_1.navigate)(Routes_1.default.HOMENAVIGATOR, { screen: Routes_1.default.HOME });
                    }),
                    Line('記事を探す', () => {
                        (0, rootNavigation_1.navigate)(Routes_1.default.SEARCH_ARTICLE_TAP, { screen: Routes_1.default.SEARCH_ARTICLE });
                    }),
                    Line('自分史を探す', () => {
                        (0, rootNavigation_1.navigate)(Routes_1.default.SEARCH_HISTORY, {
                            screen: Routes_1.default.HISTORY_SEARCH_SCREEN,
                        });
                    }),
                    Line('通知・お知らせ', () => {
                        (0, rootNavigation_1.navigate)(Routes_1.default.NOTI, { screen: Routes_1.default.NOTIFICATION_SCREEN });
                    }),
                    Line('よくある質問', () => (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, { screen: Routes_1.default.FAQ_SCREEN })),
                    Line('各種ポリシー・利用規約', () => (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, { screen: Routes_1.default.POLICY_SCREEN })),
                    Line('会社概要', () => (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, { screen: Routes_1.default.COMPANY_INFO })))))));
};
const styles = react_native_1.StyleSheet.create({
    btn: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    textBtn: {
        color: '#007AFF',
        fontSize: (0, scale_1.moderateScale)(25),
        lineHeight: (0, scale_1.moderateScale)(33),
        fontFamily: 'NotoSerifJP-Regular',
    },
    vBtn: {
        height: (0, scale_1.scale)(62),
        width: '100%',
        borderTopWidth: 1,
        borderTopColor: '#CCCCCC',
        flexDirection: 'row',
    },
    textnomal: {
        fontSize: (0, scale_1.moderateScale)(10),
        lineHeight: (0, scale_1.moderateScale)(15),
        fontWeight: '300',
        color: '#292A33',
    },
    textbold: {
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: '#292A33',
    },
    viewModal: {
        backgroundColor: '#FFFFFF',
        flex: 1,
        width: (0, scale_1.scale)(300),
        height: '100%',
    },
    viewContain: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        ...react_native_1.Platform.select({
            web: {
                cursor: 'default',
            },
        }),
    },
    line: {
        width: '100%',
        height: 1,
        backgroundColor: Colors_1.default.textHeaderOpacity60,
        marginTop: (0, scale_1.scale)(20),
    },
    input: {
        width: '100%',
        height: (0, scale_1.scale)(42),
        borderWidth: 1,
        borderColor: '#A5A5A5',
        fontFamily: 'NotoSerifJP-Regular',
        marginTop: (0, scale_1.scale)(10),
        paddingHorizontal: (0, scale_1.scale)(40),
    },
    button: {
        marginVertical: (0, scale_1.scale)(20),
        height: (0, scale_1.scale)(52),
        marginHorizontal: (0, scale_1.scale)(40),
        borderRadius: (0, scale_1.scale)(10),
        width: (0, lodash_1.min)([400, react_native_1.Dimensions.get('window').width * 0.7]),
    },
    err: {
        color: '#FF0000',
        fontSize: (0, scale_1.moderateScale)(13),
        marginBottom: (0, scale_1.scale)(10),
    },
});
exports.default = ModalMenu;
